import { ReactNode } from 'react';
import { makeObservable, observable } from 'mobx';
import { IAttachment, TMessageType } from '../types';

let maxId = 0;

export class ChatMessage {
  id: number;
  state: {
    message: ReactNode;
    messageType: TMessageType;
    attachments: IAttachment[];
    reference: ReactNode;
  };

  get message() {
    return this.state.message;
  }
  get messageType() {
    return this.state.messageType;
  }
  get attachments() {
    return this.state.attachments;
  }
  get reference() {
    return this.state.reference;
  }
  set message(value) {
    this.state.message = value;
  }
  set messageType(value) {
    this.state.messageType = value;
  }
  set attachments(value) {
    this.state.attachments = value;
  }
  set reference(value) {
    this.state.reference = value;
  }

  constructor(
    message: ReactNode = '',
    messageType: TMessageType = 'user',
    attachments: IAttachment[] = [],
    reference: ReactNode = null,
  ) {
    this.state = { message, messageType, attachments, reference };

    this.id = maxId++;
    if (messageType === 'response') this.messageType = 'system';
    if (typeof message === 'string') this.message = message;

    makeObservable(this, {
      state: observable,
    });
  }

  clone = () =>
    new ChatMessage(
      this.message,
      this.messageType,
      this.attachments.map((x) => {
        return { ...x };
      }),
      this.reference,
    );

  removeAttachment(attachment: IAttachment) {
    this.attachments = this.attachments.filter(
      (current) => current !== attachment,
    );
  }
  addAttachmentDescription(attachment: IAttachment, description: string) {
    const a = this.attachments.find((current) => current === attachment);
    if (a) {
      a.description = description;
    }
  }
  setMessageType(type: TMessageType) {
    this.messageType = type;
  }
}
